const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9 7c.553 0 1 .447 1 1 0 .553-.447 1-1 1H5c-1.654 0-3 1.346-3 3s1.346 3 3 3h4c.553 0 1 .447 1 1 0 .553-.447 1-1 1H5c-2.757 0-5-2.243-5-5s2.243-5 5-5h4zm10 0c2.757 0 5 2.243 5 5s-2.243 5-5 5h-4c-.553 0-1-.447-1-1 0-.553.447-1 1-1h4c1.654 0 3-1.346 3-3s-1.346-3-3-3h-4c-.553 0-1-.447-1-1 0-.553.447-1 1-1h4zm-2 4c.553 0 1 .447 1 1 0 .553-.447 1-1 1H7c-.553 0-1-.447-1-1 0-.553.447-1 1-1h10z",
  transform: "translate(-1264 -650) translate(312 574) translate(0 56) translate(952 20)"
});

const SvgLinkparent = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMinYMin meet",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkparent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/linkparent.52a82325.svg";
export { ForwardRef as ReactComponent };